import { useFormik } from "formik";
import { Alert, Box, Button, FormControl, Grid, TextField } from "@mui/material";
import { Iconify } from "../../common/iconify";
import TematicaService from "../../services/TematicaService";
import { useState } from "react";
import { Tematica } from "../../types/Tematica/Tematica";
import { validationTematica } from "../validationsForm/ValidationTematicaSchema";

interface Props {
    tematica: Tematica;
    onResponse?: (dataRespuesta: any) => void
}

export const TematicaForm: React.FC<Props> = ({ tematica, onResponse }) => {
    const [textoError, setTextoError] = useState('');

    const formik = useFormik<Tematica>({
        initialValues: {
            ...tematica,
            estado: 'A',
        },
        validationSchema: validationTematica,
        onSubmit: (values) => {
            if(values.idTematica === 0){
                Guardar(values)
            }else{
                Editar(values)
            }
            
        }
    });

    async function Guardar(tipo: Tematica){
        setTextoError('');
        await TematicaService.CrearTematica(tipo)
        .then(data => {
            if(data.status.isSuccessfully){
                if(onResponse){
                    onResponse(data.statusCode)
                }
            }else{
                setTextoError('No pudo guardarse')
                console.error(data.status)
            }
        }).catch(error => {
            setTextoError('No pudo guardarse')
            console.error(error)
        })
    }

    async function Editar(tipo: Tematica){
        setTextoError('');
        await TematicaService.EditarTematica(tipo)
        .then(data => {
            if(data.status.isSuccessfully){
                if(onResponse){
                    onResponse(data.statusCode)
                }
            }else{
                setTextoError('No pudo guardarse')
                console.error(data.status)
            }
        }).catch(error => {
            setTextoError('No pudo guardarse')
            console.error(error)
        })
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container direction={'row'} spacing={1}>
                <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth error={Boolean(formik.errors.txtNombre && formik.touched.txtNombre)}>
                        <TextField
                            fullWidth
                            id="txtNombre"
                            name="txtNombre"
                            label="Nombre"
                            value={formik.values.txtNombre}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.txtNombre && Boolean(formik.errors.txtNombre)}
                            sx={{ marginBottom: '20px', width: '100%' }}
                        />
                        {formik.touched.txtNombre && formik.errors.txtNombre && (
                            <Alert severity="error">{formik.errors.txtNombre}</Alert>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth error={Boolean(formik.errors.txtDescripcion && formik.touched.txtDescripcion)}>
                        <TextField
                            multiline
                            rows={2}
                            id="txtDescripcion"
                            name="txtDescripcion"
                            label="Descripción"
                            value={formik.values.txtDescripcion}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.txtDescripcion && Boolean(formik.errors.txtDescripcion)}
                            sx={{ marginBottom: '20px', width: '100%' }}
                        />
                        {formik.touched.txtDescripcion && formik.errors.txtDescripcion && (
                            <Alert severity="error">{formik.errors.txtDescripcion}</Alert>
                        )}
                    </FormControl>
                </Grid>
                {textoError !== '' ? <Alert severity="error">{textoError}</Alert> : <></>}
                <Grid item xs={12} sm={12} md={12}>
                    <Box display="flex" justifyContent="flex-end">
                        <Button type="submit" size="large" variant="contained" color='primary' endIcon={<Iconify icon={"material-symbols:save-outline"} />}>
                            Guardar
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </form>
    );
}